import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import BrandFeature from './components/BrandFeature';
import SEOArticlesSection from './components/SEOArticlesSection';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OOPBUY Spreadsheet',
  url: 'https://oopbuyspread.rest',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
  description: 'OOPBUY Spreadsheet ist das ultimative Tool für deutsche Shopper. Verwalte deine Taobao, Weidian & Yupoo Bestellungen mit QC, Agent & Shipping Tracking.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBUY Spreadsheet',
  url: 'https://oopbuyspread.rest',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://oopbuyspread.rest/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <BrandFeature />
        <SEOArticlesSection />
        <AboutSection />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
    </>
  );
}